var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "inherit", width: "100%" } },
    [
      _c(
        "el-aside",
        {
          class: {
            "aside-scrollbar": true,
            activeStyle: _vm.isActive,
            "text-act": _vm.isActives
          },
          attrs: { id: "elAside" }
        },
        [
          _c(
            "el-scrollbar",
            { staticStyle: { height: "100%" } },
            [
              _vm.isCollapse == false
                ? _c(
                    "div",
                    { staticStyle: { padding: "32px 0px 43px 38px" } },
                    [
                      _c("img", {
                        staticStyle: { width: "126px", height: "103px" },
                        attrs: { src: require("../assets/img/role-kehu.png") }
                      })
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticStyle: {
                        padding: "15px 0px",
                        color: "#eee",
                        "font-size": "16px",
                        "text-align": "center"
                      }
                    },
                    [_vm._v("\n          TIBIOT\n        ")]
                  ),
              _vm._v(" "),
              _c("side-list", { attrs: { isCollapse: _vm.isCollapse } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        {
          staticStyle: { height: "inherit", width: "100%", background: "#fff" }
        },
        [
          _c(
            "el-header",
            {
              staticStyle: {
                position: "relative",
                "border-bottom": "1px solid #f1f1f1"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "cursors",
                  staticStyle: {
                    color: "#666",
                    position: "absolute",
                    top: "15px",
                    "font-size": "26px"
                  },
                  on: { click: _vm.operationMenu }
                },
                [
                  _vm.isCollapse == false
                    ? _c("i", {
                        staticClass: "el-icon-s-fold",
                        staticStyle: { color: "#999" }
                      })
                    : _c("i", {
                        staticClass: "el-icon-s-unfold",
                        staticStyle: { color: "#999" }
                      })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "22px",
                    left: "50px"
                  }
                },
                [
                  _c(
                    "el-breadcrumb",
                    {
                      staticStyle: {
                        "font-size": "15px",
                        "padding-left": "16px"
                      }
                    },
                    _vm._l(_vm.crumbsArrss, function(item, index) {
                      return _c(
                        "el-breadcrumb-item",
                        { key: index, attrs: { to: { path: item.url } } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  staticStyle: {
                    float: "right",
                    "padding-top": "21px",
                    cursor: "pointer"
                  },
                  on: { command: _vm.handleCommand }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "el-dropdown-link",
                      staticStyle: { "font-weight": "600" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.parallelUserName
                              ? _vm.parallelUserName
                              : _vm.userName
                          )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: { icon: "el-icon-user", command: "个人中心" }
                        },
                        [_vm._v(" 个人中心")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            icon: "el-icon-switch-button",
                            command: "退出平台"
                          }
                        },
                        [_vm._v(" 退出平台")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "su" }, [_vm._v("|")]),
              _vm._v(" "),
              this.$store.state.roleId == 1
                ? _c(
                    "div",
                    {
                      staticClass: "signOut1",
                      on: {
                        click: function($event) {
                          return _vm.handleOnLine()
                        }
                      }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "平台用户登录信息",
                            placement: "bottom"
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "25px" },
                            attrs: { src: require("../assets/img/top_dl.png") }
                          })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "signOut1 flexs",
                  staticStyle: {
                    "margin-top": "14px",
                    "align-items": "center"
                  },
                  attrs: {
                    href: "https://api.tibiot.cn/docs/iot_api.html",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticStyle: { width: "32px" },
                    attrs: { src: require("../assets/img/top_api.png") }
                  }),
                  _vm._v(" "),
                  _c("strong", { staticStyle: { color: "#8cbb1a" } }, [
                    _vm._v("文档")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "signOut1 flexs",
                  staticStyle: {
                    "margin-top": "18px",
                    "align-items": "center",
                    "margin-right": "11px"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/fileDownloadMag")
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { width: "24px" },
                    attrs: { src: require("../assets/img/wenjianxz.png") }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "color_f_1" }, [_vm._v("下载中心")])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("tabsViews"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticStyle: { height: "100%" }, attrs: { id: "elMain" } },
            [
              _c(
                "el-scrollbar",
                {
                  staticClass: "main-scorllbar",
                  staticStyle: { height: "100%" }
                },
                [
                  _c(
                    "div",
                    { attrs: { id: "mainView" } },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fade-transform", mode: "out-in" } },
                        [
                          _c(
                            "keep-alive",
                            { attrs: { include: _vm.cachedViews } },
                            [
                              _c("router-view", {
                                staticStyle: {
                                  padding: "12px",
                                  "border-radius": "5px"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-backtop", {
                    attrs: {
                      target: "#elMain .el-scrollbar__wrap",
                      bottom: 72,
                      right: 22
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.roleId != 5 && _vm.roleId != 6 && _vm.roleId != 8
            ? _c(
                "el-footer",
                {
                  staticStyle: {
                    height: "38px",
                    "line-height": "38px",
                    background: "#efefef",
                    "text-align": "right"
                  }
                },
                [_vm._v("Copyright ©2021 齐犇科技集团有限公司")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退出平台，你确定吗？",
            visible: _vm.SignOut.show,
            width: "540px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.SignOut, "show", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "14px" } },
            [
              _c(
                "div",
                { staticClass: "re", staticStyle: { height: "200px" } },
                [
                  _c("img", {
                    staticClass: "ab",
                    staticStyle: { width: "300px", top: "-66px", left: "92px" },
                    attrs: { src: require("../assets/img/Out_pt.svg"), alt: "" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", round: "", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleAdopt("SignOut")
                    }
                  }
                },
                [_vm._v("我确定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.onLine.drawer
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "用户登录信息",
                width: "880px",
                fullscreen: true,
                visible: _vm.onLine.drawer,
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.onLine, "drawer", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "formInline",
                  staticClass: "demo-form-inline Query_box",
                  attrs: {
                    model: _vm.queryVal,
                    inline: true,
                    size: "small",
                    "label-width": "82px"
                  }
                },
                _vm._l(_vm.formInlines, function(item, index) {
                  return _c(
                    "el-form-item",
                    {
                      key: index,
                      attrs: { label: item.label, prop: item.prop }
                    },
                    [
                      item.type == "input"
                        ? [
                            _c("el-input", {
                              staticStyle: { width: "260px" },
                              attrs: { placeholder: item.pleas },
                              model: {
                                value: _vm.queryVal[item.prop],
                                callback: function($$v) {
                                  _vm.$set(_vm.queryVal, item.prop, $$v)
                                },
                                expression: "queryVal[item.prop]"
                              }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "boderbottom",
                  staticStyle: { "margin-bottom": "20px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        round: "",
                        plain: "",
                        size: "mini",
                        icon: "el-icon-search"
                      },
                      on: {
                        click: function($event) {
                          return _vm.flowQuery()
                        }
                      }
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        round: "",
                        plain: "",
                        size: "mini",
                        icon: "el-icon-refresh"
                      },
                      on: {
                        click: function($event) {
                          return _vm.flowRefresh()
                        }
                      }
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        round: "",
                        plain: "",
                        size: "mini",
                        icon: "el-icon-refresh-right"
                      },
                      on: {
                        click: function($event) {
                          return _vm.flowQuery()
                        }
                      }
                    },
                    [_vm._v("刷新")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableDataObj.loading,
                      expression: "tableDataObj.loading"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    "element-loading-text": "拼命加载中 ...",
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(255, 255, 255, .9)",
                    data: _vm.tableDataObj.tableData,
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", label: "序号", width: "50" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.checkList, function(index) {
                    return _c("el-table-column", {
                      key: index,
                      attrs: {
                        prop: _vm.tableDataObj.tableLabel[index].prop,
                        label: _vm.tableDataObj.tableLabel[index].showName,
                        width: _vm.tableDataObj.tableLabel[index].width
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatters")(
                                        scope.row[
                                          _vm.tableDataObj.tableLabel[index]
                                            .prop
                                        ],
                                        _vm.tableDataObj.tableLabel[index]
                                          .formatData
                                      )
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "list-btn-pad",
                    attrs: { label: "操作", width: "70px" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "them-color-w cursors",
                                  on: {
                                    click: function($event) {
                                      return _vm.KickOut(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-circle-close"
                                  }),
                                  _vm._v(" 踢出")
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3205193134
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "12px", "text-align": "right" }
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "pager-count": 5,
                      background: "",
                      "current-page": _vm.queryVal.pageNum,
                      layout: "total, prev, pager, next",
                      total: _vm.tableDataObj.totalSize
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", round: "", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.onLine.drawer = false
                        }
                      }
                    },
                    [_vm._v("知道了")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54d3a52e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../45/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54d3a52e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../45/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = null
// module chunks = 